// extracted by mini-css-extract-plugin
module.exports = {"paginationWrap":"pagination-module--pagination-wrap--3-tX8","pagination":"pagination-module--pagination--3WXpU","active":"pagination-module--active--1HtUn"};